<script lang="ts">

  import { page } from "$app/state"
  import httpClient from "$lib/axios-client"
  import type { _response } from "$lib/data/type/_response"
  import Loader from "$lib/components/loader.svelte"
  import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "$lib/components/ui/dialog"
  import { Label } from "$lib/components/ui/label"
  import { getLocalTimeZone, today } from "@internationalized/date"
  import { createQuery } from "@tanstack/svelte-query"
  import CardDate from "../../../(main)/home/_components/card-date.svelte"
  import GridActivity from "./grid-activity.svelte"
  import type { Staff } from "../_types"

  let {
    open,
    setOpen,
    select,
  }: {
    open: boolean
    setOpen: (value: boolean) => void
    select: number
  } = $props()

  const prefix = $derived(page.params.prefix ?? "0")
  let date = $state(today(getLocalTimeZone()))

  const query = createQuery(() => ({
    enabled: open && !!select,
    queryKey: ["staff-detail", prefix, select],
    queryFn: async () => {
      const response = await httpClient.get<_response<Staff>>(`/api/${prefix}/staffs/${select}`)
      return response.data.result
    },
  }))

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}>
  <DialogContent
    class="w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}>
    <DialogHeader>
      <DialogTitle>Detail</DialogTitle>
      <DialogDescription></DialogDescription>
    </DialogHeader>
    <Loader show={query.isFetching}/>
    <div class="space-y-4">
      {#if query.isError}
        <div
          class="text-xs text-destructive"
          role="alert">
          Detail tidak dapat dimuat
        </div>
      {/if}
      <CardDate
        value={date}
        onChange={(value) => (date = value)}/>
      <GridActivity
        salesId={select}
        date={date}
        prefix={prefix}/>
      <div>
        <h3 class="mb-1 text-sm font-semibold">Detail</h3>
        <div class="space-y-3">
          <div>
            <Label>Nama</Label>
            <div class="text-desc">{query.data?.name || "-"}</div>
          </div>
          <div>
            <Label>Nomor</Label>
            <div class="text-desc font-mono">{query.data?.number || "-"}</div>
          </div>
          <div class="flex gap-2">
            <div class="flex-1">
              <Label>Jabatan</Label>
              <div class="text-desc">{query.data?.rank.name || "-"}</div>
            </div>
            <div class="flex-1">
              <Label>Posisi</Label>
              <div class="text-desc">{query.data?.position.name || "-"}</div>
            </div>
          </div>
          <div>
            <Label>Telepon</Label>
            <div class="text-desc font-mono">{query.data?.phone || "-"}</div>
          </div>
          <div>
            <Label>Email</Label>
            <div class="text-desc">{query.data?.email || "-"}</div>
          </div>
          <div>
            <Label>Status</Label>
            <div class="text-desc">{query.data ? (query.data.status ? "Aktif" : "Tidak") : "-"}</div>
          </div>
        </div>
      </div>
    </div>
  </DialogContent>
</Dialog>
